module.exports = "/_next/static/images/icon-check-blue-a1aeb335a341b6e255224c6cf266d466.svg";